import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppSelector } from '../store'

const ProtectedRoute = () => {
  const location = useLocation()
  const user = useAppSelector((state) => state.user)
  console.log(user)
  if (user.isAuthenticated) {
    return <Outlet />
  }
  return <Navigate to="/login" state={{ from: location }} />
}

export default ProtectedRoute
